<template>
  <ui-popover :open="isOpen" @update:open="(value) => isOpen = value">
    <ui-popover-trigger as-child>
      <button
        type="button"
        data-slot="company-switcher"
        class="glass-panel flex h-9 w-full items-center gap-3 rounded-xl px-3 text-left transition-colors hover:bg-sidebar-accent"
      >
        <span class="min-w-0 flex-1 truncate text-sm font-semibold text-sidebar-foreground">
          {{ currentCompanyLabel }}
        </span>
        <chevrons-up-down-icon class="size-4 shrink-0 text-muted-foreground" />
      </button>
    </ui-popover-trigger>

    <ui-popover-content align="start" class="w-60 p-0">
      <ui-command>
        <ui-command-input :placeholder="tr('Search') + '...'" />
        <ui-command-list>
          <ui-command-empty>{{ tr('No results') }}</ui-command-empty>
          <ui-command-group>
            <ui-command-item
              v-for="company of availableCompanies"
              :key="'company-switcher-' + company.id"
              :value="company.label"
              @select="() => select(company.id)"
            >
              <loader-circle-icon v-if="loadingCompanyId === company.id" class="animate-spin" />
              <star-icon v-else-if="company.id === $root.loggedInUser.company.id" />
              <span class="truncate">{{ company.label }}</span>
              <check-icon v-if="company.id === currentCompanyId" class="ml-auto" />
            </ui-command-item>
          </ui-command-group>
        </ui-command-list>
        <div class="border-t p-1">
          <router-link
            to="/managed-companies"
            class="flex h-8 items-center rounded-md px-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
            @click="() => onClickShowAll()"
          >
            {{ tr('Show all') }}
          </router-link>
        </div>
      </ui-command>
    </ui-popover-content>
  </ui-popover>
</template>

<script>
import { Check, ChevronsUpDown, LoaderCircle, Star } from '@lucide/vue';

export default {
  name: 'CompanySwitcher',
  components: {
    CheckIcon: Check,
    ChevronsUpDownIcon: ChevronsUpDown,
    LoaderCircleIcon: LoaderCircle,
    StarIcon: Star,
  },
  emits: [ 'navigate' ],
  data: () => ({
    isOpen: false,
    loadingCompanyId: null,
  }),
  computed: {
    currentCompanyId() {
      return this.$root.currentCompany.id;
    },
    currentCompanyLabel() {
      const currentCompany = this.availableCompanies.find(i => i.id === this.currentCompanyId);
      return currentCompany ? currentCompany.label : 'Unknown company';
    },
    availableCompanies() {
      const originalCompany = this.$root.loggedInUser.company;
      const companies = originalCompany.managed_companies.map(company => ({
        id: company.id,
        label: this.getCompanyLabel(company),
      }));

      companies.sort((a, b) => a.label.localeCompare(b.label));
      companies.unshift({
        id: originalCompany.id,
        label: this.getCompanyLabel(originalCompany),
      });

      return companies;
    },
  },
  methods: {
    select(companyId) {
      if (
        this.loadingCompanyId !== null
        || companyId === this.currentCompanyId
      ) {
        return;
      }

      this.loadingCompanyId = companyId;

      this.$store.commit('auth/selectCompany', companyId);

      setTimeout(() => window.location = '/dashboard', 250);
    },
    onClickShowAll() {
      this.isOpen = false;
      this.$emit('navigate');
    },
    getCompanyLabel(company) {
      if (company.name) {
        return company.name;
      }
      if (company.billing_company) {
        return company.billing_company;
      }
      if (company.owner && company.owner.fullname) {
        return company.owner.fullname;
      }
      return String(company.id);
    },
  },
};
</script>
